import Layout from '@/layout';

export default {
  weight: 18,
  path: '/feedback',
  component: Layout,
  redirect: '/feedbackList',
  name: 'feedback',
  meta: { title: '意见反馈管理', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'feedbackList',
      name: 'feedbackList',
      component: () => import('@/views/feedback/feedbackList'),
      meta: { title: '意见反馈', icon: 'el-icon-s-data' },
    },
    {
      path: 'feedbackDetails',
      name: 'feedbackDetails',
      component: () => import('@/views/feedback/feedbackDetails'),
      meta: { title: '意见反馈详情', icon: 'el-icon-s-data', activeMenu: '/feedback/feedbackList' },
      hidden: true,
    },
  ],
};
